import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    body: {
        height: '100%',
        padding: 10,

        [theme.breakpoints.down('xs')]: {
            marginTop: 54
        },
        [theme.breakpoints.up('sm')]: {
            marginTop: 64
        }
    }
}));

function Body(
    {
        children
    }
) {
    const classes = useStyles();

    return (
        <div className={classes.body}>
            {children}
        </div>
    )
}

export default Body;